import { axiosPost, axiosGet } from "../../react_axios/Axios"
import { platform, headers, loginUserUrl, forgetUpdatePasswordUrl, FORGET_UPDATE_PASSWORD_ACTION_TYPE, forgetGetOtpUrl, FORGET_GET_OTP_ACTION_TYPE, LOGIN_ACTION_TYPE, forgetPasswordUrl, FORGET_PASSWORD_ACTION_TYPE, updatePasswordUrl, UPDATE_PASSWORD_ACTION_TYPE, getCredentialUrl, GET_LOGIN_PASS_ACTION_TYPE, VERIFY_OTP_ACTION_TYPE, verifyOtpUrl } from "../../utils/constants"

export const login_action = (UserName, password) => async (dispatch) => {

    try {
        const mapdata = {
            UserName: UserName,
            password: password,
        }
        console.log("data----------", mapdata)
        const res = await axiosPost(loginUserUrl, mapdata, headers);

        if (res != null) {
            console.log("login_action", res)
            sessionStorage.clear()
            // sessionStorage.setItem('UserLoginData', res)
            // sessionStorage.setItem('UserName', res.data['Email'])

            // sessionStorage.setItem('UserId', res.data['LoginID'])
            // sessionStorage.setItem('LoginRoleId', res.data['Roleid'])
            // sessionStorage.setItem('LoginAccesslist', JSON.stringify(res.data['loginAccesslist']))
            // sessionStorage.setItem('ReportAccesslist', JSON.stringify(res.data['reportAccesslist']))

        }

        dispatch({
            type: LOGIN_ACTION_TYPE,
            payload: res,
        });

        return Promise.resolve(res);
    } catch (err) {
        return Promise.reject(err);
    }
};

export const forgetPassword_action = (Username) => async (dispatch) => {
    try {
        const mapdata = {
            UserID: null,
            Username: Username.toString().trim(),
        }

        const res = await axiosPost(forgetPasswordUrl, mapdata, headers);
        dispatch({
            type: FORGET_PASSWORD_ACTION_TYPE,
            payload: res,
        });

        return Promise.resolve(res);
    } catch (err) {
        return Promise.reject(err);
    }
};

export const forgetGetOtp_action = (email) => async (dispatch) => {
    try {
        const mapdata = {
            Email: email.toString().trim(),
        }

        const res = await axiosPost(forgetGetOtpUrl, mapdata, headers);
        dispatch({
            type: FORGET_GET_OTP_ACTION_TYPE,
            payload: res,
        });

        return Promise.resolve(res);
    } catch (err) {
        return Promise.reject(err);
    }
};
export const verifyOtp_action = (otp) => async (dispatch) => {
    try {
        const mapdata = {
            otp: otp
        }

        const res = await axiosPost(verifyOtpUrl, mapdata, headers);
        dispatch({
            type: VERIFY_OTP_ACTION_TYPE,
            payload: res,
        });
        return Promise.resolve(res);
        
    } catch (err) {
        console.error("Network or request error:", err);
        return Promise.reject(err);
    }
};
export const forgetUpdatePassword_action = (UserID, password) => async (dispatch) => {
    try {
        const mapdata = {
            UserID: UserID,
            Password: password,
        }

        const res = await axiosPost(forgetUpdatePasswordUrl, mapdata, headers);
        dispatch({
            type: FORGET_UPDATE_PASSWORD_ACTION_TYPE,
            payload: res,
        });

        return Promise.resolve(res);
    } catch (err) {
        return Promise.reject(err);
    }
};

export const updatePassword_action = (OldPassword, NewPassword) => async (dispatch) => {
    try {
        const mapdata = {
            UserID: parseInt(JSON.parse(sessionStorage.getItem('loginDataSS')).UserID),
            OldPassword: OldPassword,
            NewPassword: NewPassword,
        }

        const res = await axiosPost(updatePasswordUrl, mapdata, headers);
        dispatch({
            type: UPDATE_PASSWORD_ACTION_TYPE,
            payload: res,
        });

        return Promise.resolve(res);
    } catch (err) {
        return Promise.reject(err);
    }
};

export const getCredential_action = () => async (dispatch) => {

    try {
        const params = {
            MemberID: JSON.parse(sessionStorage.getItem('loginDataSS')).MemberID,
        }
        console.log("ReceiptList-Action--------------------------->", params)

        const res = await axiosGet(getCredentialUrl, params, headers);
        dispatch({
            type: GET_LOGIN_PASS_ACTION_TYPE,
            payload: res,
        });

        return Promise.resolve(res);
    } catch (err) {
        return Promise.reject(err);
    }

}